import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = {
  key: 1,
  class: "remind-ball"
}
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return ((_ctx.item && _ctx.seen))
    ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["form-components", {'el-form-item is-error':_ctx.store.state.errorFileList.includes(_ctx.item.field)}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field])
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: _ctx.item.remark||_ctx.stateFieldRemark[_ctx.item.field],
                "popper-class": "remark-popper",
                placement: "top-start",
                trigger: "click"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: "https://images.goworkla.cn/wxAppletImg/EnergyValue_result_about.png",
                    class: "label-remark"
                  }, null, -1)
                ])),
                _: 1,
                __: [1]
              }, 8, ["content"]))
            : _createCommentVNode("", true),
          (_ctx.item.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(_ctx.item.name), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.list)
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: _ctx.datavalue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datavalue) = $event)),
                disabled: _ctx.item.is_disable,
                placeholder: _ctx.item.prompt_msg||`请选择${_ctx.item.name}`,
                "allow-create": _ctx.item.allow_create,
                filterable: _ctx.item.allow_create||_ctx.item.filterable,
                onChange: _ctx.change
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.text,
                      value: item.code,
                      disabled: item.disabled
                    }, null, 8, ["label", "value", "disabled"])), [
                      [_vShow, item.text!='三资企业']
                    ])
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "placeholder", "allow-create", "filterable", "onChange"]))
            : _createCommentVNode("", true)
        ])
      ], 2)), [
        [_vShow, _ctx.item.field != 'graduation']
      ])
    : _createCommentVNode("", true)
}